import GuidedSearchHelper from '@organisms/guided-search/guidedSearchHelper';
import requests from '@tools/requests';
import { flashBagError } from '../../flashbag';
import { URL_GUIDED_SEARCH_CREATE } from '../../routes/routes';

function getSteps() {
  const steps = [];
  for (let i = 1; i <= 6; i++) {
    steps.push({
      title: `guided_search.step.${i}.title`,
    });
  }
  return steps;
}

const getDefaultState = () => ({
  actualStep: 0,
  displayStepperModal: false,
  steps: getSteps(),
  stepValues: {
    installationMonth: null,
    location: null,
    capacity: null,
    duration: null,
    budget: {
      price: null,
      isUnknown: false,
    },
    organization: null,
    user: {
      fullName: '',
      email: '',
      phoneNumber: '',
      phoneNumberIsValid: false,
    },
  },
  userData: null,
  offersCount: 0,
  customSearchUrl: '',
});

// initial state
const state = getDefaultState();

// getters
const getters = {
  actualStep: (state) => state.actualStep,
  actualStepTitle: (state) => {
    if (state.actualStep < 0) {
      return state.steps[0].title;
    }

    if (state.actualStep >= state.steps.length) {
      return state.steps[state.steps.length - 1].title;
    }

    return state.steps[state.actualStep].title;
  },
  totalSteps: (state) => state.steps.length,
  displayStepperModal: (state) => state.displayStepperModal,
  stepperInfoModal: (state) => state.displayStepperModal,
  steps: (state) => state.steps,
  getStepValue: (state) => (step) => state.stepValues[step],
  getAllStepValues: (state) => state.stepValues,
  getUserDefaultInfosData: (state) => state.userData,
  getUserData: (state) => state.userData,
  getOffersCount: (state) => state.offersCount,
  getCustomSearchUrl: (state) => state.customSearchUrl,
};

// actions
const actions = {
  RESET_VALUE({ commit }) {
    commit('RESET_VALUE');
  },
  CHANGE_ACTUAL_STEP({ commit }, step) {
    commit('SET_ACTUAL_STEP', step);
  },
  CHANGE_DISPLAY_STEPPER_MODAL({ commit }, displayStepperModal) {
    commit('SET_DISPLAY_STEPPER_MODAL', displayStepperModal);
  },
  SET_USER_DATA({ commit }) {
    commit('SET_USER_DATA');
  },
  async SEND_DATA({ state, commit }) {
    try {
      const requestData = GuidedSearchHelper.formatDataStore(state.stepValues);

      const response = await requests.post(
        URL_GUIDED_SEARCH_CREATE,
        requestData,
      );

      if (response.status !== 200) {
        throw new Error();
      }

      commit('SET_OFFERS_COUNT', response.data.offers_count);
      commit('SET_CUSTOM_SEARCH_URL', response.data.search_url);

      window.dataLayer.push({
        event: 'screenChange',
        step: 'completion',
        funnel: 'support-contact-form',
        ...response.data.data,
      });

      return true;
    } catch (error) {
      flashBagError();
      return false;
    }
  },
};

// mutations
const mutations = {
  SET_ACTUAL_STEP(state, step) {
    state.actualStep = step;
  },
  SET_DISPLAY_STEPPER_MODAL(state, displayStepperModal) {
    state.displayStepperModal = displayStepperModal;
  },
  RESET_VALUE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_STEP_VALUE(state, payload) {
    if (!payload.stepDetails) {
      state.stepValues[payload.step] = payload.value;
      return;
    }
    state.stepValues[payload.step][payload.stepDetails] = payload.value;
  },
  SET_USER_DATA(state) {
    state.userData = window.initialAppState.user_data;
  },
  SET_OFFERS_COUNT(state, payload) {
    state.offersCount = payload;
  },
  SET_CUSTOM_SEARCH_URL(state, payload) {
    state.customSearchUrl = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
